













import { Component, Vue, Prop } from 'vue-property-decorator'
import ClickOutside from 'vue-click-outside'

@Component({
  directives: {
    ClickOutside,
  },
})
export default class Contextmenu extends Vue {
  @Prop({ required: true }) public top!: number
  @Prop({ required: true }) public left!: number
  @Prop({ required: true }) public visible!: boolean

  private handleClickoutside() {
    if (this.visible) {
      this.$emit('update:visible', false)
    }
  }
}
